import { render, staticRenderFns } from "./link.vue?vue&type=template&id=ef7b8738&scoped=true&"
import script from "./link.vue?vue&type=script&lang=ts&"
export * from "./link.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef7b8738",
  null
  
)

export default component.exports